import React from 'react'

const BetaLabel = ({ label }) => (
  <React.Fragment>
    {label}
    <sup>beta</sup>
  </React.Fragment>
)

export default BetaLabel;
